// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_spot_operation_log_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { BiddingBlockBidGroupType, BiddingBlockBidType } from "./bidding_block_model_pb";
import { file_bffuser_v1_bidding_block_model } from "./bidding_block_model_pb";
import type { BiddingSpotOrderMethod } from "./bidding_spot_model_pb";
import { file_bffuser_v1_bidding_spot_model } from "./bidding_spot_model_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_spot_operation_log_model.proto.
 */
export const file_bffuser_v1_bidding_spot_operation_log_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_side, file_bffuser_v1_bidding_block_model, file_bffuser_v1_bidding_spot_model, file_google_protobuf_timestamp, file_google_type_decimal]);

/**
 * スポット入札の操作履歴 1 件 (BFF mirror、 backend `internalapi.v1.SpotOperationLog` と 1:1)。
 *
 * @generated from message bffuser.v1.BiddingSpotOperationLog
 */
export type BiddingSpotOperationLog = Message<"bffuser.v1.BiddingSpotOperationLog"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bffuser.v1.BiddingSpotOperationLogBidKind bid_kind = 2;
   */
  bidKind: BiddingSpotOperationLogBidKind;

  /**
   * @generated from field: bffuser.v1.BiddingBidOperationType operation_type = 3;
   */
  operationType: BiddingBidOperationType;

  /**
   * @generated from field: optional string reason = 4;
   */
  reason?: string;

  /**
   * @generated from field: optional string operated_by = 5;
   */
  operatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp operated_at = 6;
   */
  operatedAt?: Timestamp;

  /**
   * @generated from field: bffuser.v1.BiddingBlockBidGroupType block_group_type = 7;
   */
  blockGroupType: BiddingBlockBidGroupType;

  /**
   * @generated from field: repeated bffuser.v1.BiddingSpotOperationLogLine lines = 8;
   */
  lines: BiddingSpotOperationLogLine[];
};

/**
 * Describes the message bffuser.v1.BiddingSpotOperationLog.
 * Use `create(BiddingSpotOperationLogSchema)` to create a new message.
 */
export const BiddingSpotOperationLogSchema: GenMessage<BiddingSpotOperationLog> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_operation_log_model, 0);

/**
 * 操作の対象になった札 1 枚 (ブロック入札は Leg 1 本) の、 操作した時点の値 (BFF mirror)。
 *
 * @generated from message bffuser.v1.BiddingSpotOperationLogLine
 */
export type BiddingSpotOperationLogLine = Message<"bffuser.v1.BiddingSpotOperationLogLine"> & {
  /**
   * @generated from field: bffuser.v1.BiddingBlockBidType block_bid_type = 1;
   */
  blockBidType: BiddingBlockBidType;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.Side direction = 3;
   */
  direction: Side;

  /**
   * @generated from field: int32 time_code_from = 4;
   */
  timeCodeFrom: number;

  /**
   * @generated from field: int32 time_code_to = 5;
   */
  timeCodeTo: number;

  /**
   * @generated from field: bffuser.v1.BiddingSpotOrderMethod order_method = 6;
   */
  orderMethod: BiddingSpotOrderMethod;

  /**
   * @generated from field: optional google.type.Decimal price_yen_per_kwh = 7;
   */
  priceYenPerKwh?: Decimal;

  /**
   * @generated from field: repeated bffuser.v1.BiddingSpotOperationLogSlotVolume slot_volumes = 8;
   */
  slotVolumes: BiddingSpotOperationLogSlotVolume[];

  /**
   * @generated from field: optional string jepx_bid_no = 9;
   */
  jepxBidNo?: string;

  /**
   * @generated from field: optional string delivery_contract_code = 10;
   */
  deliveryContractCode?: string;

  /**
   * @generated from field: optional string workflow_id = 11;
   */
  workflowId?: string;
};

/**
 * Describes the message bffuser.v1.BiddingSpotOperationLogLine.
 * Use `create(BiddingSpotOperationLogLineSchema)` to create a new message.
 */
export const BiddingSpotOperationLogLineSchema: GenMessage<BiddingSpotOperationLogLine> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_operation_log_model, 1);

/**
 * @generated from message bffuser.v1.BiddingSpotOperationLogSlotVolume
 */
export type BiddingSpotOperationLogSlotVolume = Message<"bffuser.v1.BiddingSpotOperationLogSlotVolume"> & {
  /**
   * @generated from field: int32 time_code = 1;
   */
  timeCode: number;

  /**
   * @generated from field: google.type.Decimal volume_mw = 2;
   */
  volumeMw?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingSpotOperationLogSlotVolume.
 * Use `create(BiddingSpotOperationLogSlotVolumeSchema)` to create a new message.
 */
export const BiddingSpotOperationLogSlotVolumeSchema: GenMessage<BiddingSpotOperationLogSlotVolume> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_operation_log_model, 2);

/**
 * 操作履歴に記録する操作の種類 (BFF mirror、 backend `internalapi.v1.BidOperationType` と 1:1)。
 *
 * @generated from enum bffuser.v1.BiddingBidOperationType
 */
export enum BiddingBidOperationType {
  /**
   * @generated from enum value: BIDDING_BID_OPERATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_BID_OPERATION_TYPE_CANCEL = 1;
   */
  CANCEL = 1,

  /**
   * @generated from enum value: BIDDING_BID_OPERATION_TYPE_REOPEN = 2;
   */
  REOPEN = 2,

  /**
   * @generated from enum value: BIDDING_BID_OPERATION_TYPE_WITHDRAW = 3;
   */
  WITHDRAW = 3,

  /**
   * @generated from enum value: BIDDING_BID_OPERATION_TYPE_RESERVATION_CANCEL = 4;
   */
  RESERVATION_CANCEL = 4,

  /**
   * @generated from enum value: BIDDING_BID_OPERATION_TYPE_RETURN_TO_DRAFT = 5;
   */
  RETURN_TO_DRAFT = 5,

  /**
   * @generated from enum value: BIDDING_BID_OPERATION_TYPE_JEPX_RECONCILE = 6;
   */
  JEPX_RECONCILE = 6,
}

/**
 * Describes the enum bffuser.v1.BiddingBidOperationType.
 */
export const BiddingBidOperationTypeSchema: GenEnum<BiddingBidOperationType> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_spot_operation_log_model, 0);

/**
 * オペレーション履歴の入札種別 (BFF mirror、 backend `internalapi.v1.SpotOperationLogBidKind` と 1:1)。
 *
 * @generated from enum bffuser.v1.BiddingSpotOperationLogBidKind
 */
export enum BiddingSpotOperationLogBidKind {
  /**
   * @generated from enum value: BIDDING_SPOT_OPERATION_LOG_BID_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_SPOT_OPERATION_LOG_BID_KIND_NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * @generated from enum value: BIDDING_SPOT_OPERATION_LOG_BID_KIND_BLOCK = 2;
   */
  BLOCK = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingSpotOperationLogBidKind.
 */
export const BiddingSpotOperationLogBidKindSchema: GenEnum<BiddingSpotOperationLogBidKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_spot_operation_log_model, 1);

